<template>
  <el-card>
    <el-row class="feedback__title">评分反馈</el-row>
    <!-- 搜索 -->
    <el-row class="feedback__search">
      <span>国家：</span>
      <el-select
        v-model="searchList.countryCode"
        filterable
        clearable
        placeholder="请选择"
        style="width: 150px"
      >
        <el-option
          v-for="item in countryList"
          :key="item.countryCode"
          :label="item.country"
          :value="item.countryCode"
        >
        </el-option>
      </el-select>
      <span>渠道：</span>
      <el-select
        v-model="searchList.channel"
        filterable
        clearable
        placeholder="请选择"
        style="width: 200px"
      >
        <el-option
          v-for="item in channelList"
          :key="item.channelId"
          :label="item.name"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span>回复状态：</span>
      <el-select
        v-model="searchList.replied"
        filterable
        clearable
        placeholder="请选择"
        style="width: 100px"
      >
        <el-option
          v-for="item in repliedStatus"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span>时间范围：</span>
      <el-date-picker
        v-model="searchList.times"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        value-format="timestamp"
      >
      </el-date-picker>
      <el-button
        type="primary"
        style="margin-left: 20px"
        @click="getFeedbackConfig(1)"
        >搜索</el-button
      >
      <el-button
        type="success"
        style="margin-left: 20px"
        @click="exportFeedback"
        >导出</el-button
      >
    </el-row>
    <!-- 表格数据 -->
    <el-row>
      <el-table border :data="table">
        <el-table-column prop="id" label="id" align="center"> </el-table-column>
        <el-table-column prop="channel" label="渠道" align="center">
        </el-table-column>
        <el-table-column prop="countryCode" label="国家" align="center">
        </el-table-column>
        <el-table-column
          prop="ctime"
          label="创建时间"
          align="center"
          :formatter="formatDate"
        >
        </el-table-column>
        <el-table-column prop="uid" label="反馈人uid" align="center">
        </el-table-column>
        <el-table-column prop="content" label="反馈问题描述" align="center">
        </el-table-column>
        <el-table-column label="回复状态" align="center">
          <template slot-scope="scope">
            {{ scope.row.replied == 0 ? '未回复' : scope.row.replyContent }}
          </template>
        </el-table-column>
        <el-table-column prop="operator" label="回复人" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              v-if="scope.row.replied != 1"
              @click="
                () => {
                  dialogVisible = true
                  replayInfo.scoreFeedbackId = scope.row.id
                }
              "
              >回复</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 分页 -->
    <el-pagination
      background
      layout="prev, pager, next"
      :total="total"
      :page-size="30"
      @current-change="changePage"
    >
    </el-pagination>
    <!-- 弹窗 -->
    <el-dialog :visible.sync="dialogVisible" title="回复" @close="closes">
      <el-input
        type="textarea"
        :autosize="{ minRows: 4 }"
        placeholder="请输入内容"
        v-model="replayInfo.replyContent"
      >
      </el-input>
      <el-button
        style="margin-top: 10px"
        type="primary"
        @click="feedback(replayInfo)"
        >回复</el-button
      >
    </el-dialog>
  </el-card>
</template>

<script>
import download from '@/utils/download.js'
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      searchList: {
        replied: null,
        countryCode: null,
        channel: null,
        times: null,
      },
      repliedStatus: [
        { name: 'all', value: null },
        { name: '未回复', value: 0 },
        { name: '已回复', value: 1 },
      ],
      dialogVisible: false,
      replayInfo: {
        scoreFeedbackId: null,
        replyContent: null,
      },
      table: [],
      channelList: [],
      countryList: [],
      currentPage: 1,
      total: 0,
    }
  },
  watch: {},
  mounted() {
    this.getAllBeforeDate()
  },
  methods: {
    // 确认
    submit() {},
    // 获取所有前置数据
    getAllBeforeDate() {
      this.getChannel()
      this.getCountryCode()
      this.getFeedbackConfig(1)
    },
    changePage(page) {
      this.currentPage = page
    },
    closes() {
      this.replayInfo = {
        scoreFeedbackId: null,
        replyContent: null,
      }
    },
    // 回复
    async feedback(info) {
      if (!info.replyContent) return this.$message.error('回复内容不能为空')
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.score_feedback_reply,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data: {
          ...info,
        },
      })
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success("回复成功")
        this.getFeedbackConfig();
        this.dialogVisible = false
      }
    },
    // 获取反馈数据
    async getFeedbackConfig(page) {
      if (page) {
        this.currentPage = page
      }
      const data = JSON.parse(JSON.stringify(this.searchList))
      if (data.times) {
        data.start = data.times[0] / 1000 || null
        data.end = data.times[1] / 1000 || null
      }
      delete data.times
      console.log(data)
      const { data: res } = await this.$axios({
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.score_feedback_query,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          ...data,
          page: this.currentPage,
        },
      })

      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.table = res.data.data
        this.total = res.data.total
      }
    },
    // 导出反馈数据
    async exportFeedback() {
      const data = JSON.parse(JSON.stringify(this.searchList))
      if (data.times) {
        data.start = data.times[0] / 1000 || null
        data.end = data.times[1] / 1000 || null
      }
      delete data.times
      const { data: res } = await this.$axios({
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        responseType: 'blob',
        url: this.$store.getters.path.score_feedback_export,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          ...data,
          page: this.currentPage,
        },
      })
      this.$message.success('开始下载')
      download(res.data, '反馈数据')
    },
    // 获取渠道选项
    async getChannel() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url:
          this.$store.getters.path.channelList +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.channelList = [
          { channelId: -1, name: 'all', value: 'all' },
          ...res.data,
        ]
      }
    },
    // 获取国家选项
    async getCountryCode() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url:
          this.$store.getters.path.normal_country +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.countryList = res.data.countryList
      }
    },
    // 格式化时间
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property] * 1000
      console.log("-=-=-=-=-=")
      console.log(data);
      if (data == null) {
        return null
      }
      let dt = new Date(data)
      return (
        dt.getFullYear() +
        '-' +
        (dt.getMonth() + 1) +
        '-' +
        dt.getDate() +
        ' ' +
        dt.getHours() +
        ':' +
        dt.getMinutes() +
        ':' +
        dt.getSeconds()
      )
    },
  },
}
</script>

<style scoped lang="scss">
.feedback {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  &__search {
    span {
      font-size: 20px;
      font-weight: 600;
      margin-right: 15px;
      margin-left: 15px;
    }

    .searchBtn {
      margin-left: 10px;
    }
  }
}
</style>
